export default "__VITE_ASSET__JM_2$AUY__"